// src/features/owner/sections/system/SystemHealthSection.tsx — live health status for each service component.
import { useOwnerHealth } from '@/hooks';
import { OwnerPanel, EmptyState, StatusDot } from '../../components';

export function SystemHealthSection() {
  const { data, loading, error } = useOwnerHealth();
  if (loading) return <p style={{ opacity: 0.6 }}>Loading…</p>;
  if (error || !data) return <EmptyState icon="activity" message={error ?? 'No data'} />;
  return (
    <OwnerPanel title="System Health">
      {data.components.map((c) => (
        <div key={c.key} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0' }}>
          <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <StatusDot status={c.status} /> {c.label}
          </span>
          <b style={{ textTransform: 'capitalize' }}>{c.status}</b>
        </div>
      ))}
    </OwnerPanel>
  );
}
